export const site = {
  name: 'TOTAL Home Improvement',
  shortName: 'TOTAL Home Imp',
  url: 'https://www.totalhomeimp.com/',
  tagline: 'Repair. Update. Renovate.',
  estimatePhone: {
    label: 'Free Estimates',
    display: '248-761-7595',
    alt: '1-248-761-7595',
    href: 'tel:+12487617595',
  },
  plumbingPhone: {
    label: 'Plumbing Line',
    display: '248-761-7595',
    href: 'tel:+12487617595',
  },
  email: 'murraytotalhome@gmail.com',
  emailHref: 'mailto:murraytotalhome@gmail.com',
  address: {
    company: 'Total Home Improvement',
    line1: 'P.O. Box 930451',
    city: 'Wixom',
    state: 'MI',
    zip: '48393',
  },
  logo: 'https://cdn.magicpatterns.com/uploads/o9NuJ3vajkxK6fBBv53NVs/total-home-improvement-logo-orange-header.png',
  logoAlt: 'TOTAL Home Improvement',
  social: {
    facebook: 'https://www.facebook.com/TOTALhomeimp/',
    houzz:
      'https://www.houzz.com/professionals/general-contractors/total-home-improvement-pfvwus-pf~152375771',
    bbb: 'https://www.bbb.org/us/mi/wixom/profile/home-improvement/total-home-improvement-0372-90004709',
  },
}

export const images = {
  bbb: 'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/v1img/bbb.png?opt=5',
  epa: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FEPA.jpg&site=5137&w=199&h=119&user=3585&opt=5',
  home: 'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/v1img/home_home.jpg?opt=5',
  servicesTag:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/v1img/servicesTAG.jpg?opt=5',
  about:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/TotalHomeImpAboutUs.jpg?opt=5',
  building:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/BuildingPict.jpg?opt=5',
  plumbing:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/PlumbingPicts.jpg?opt=5',
  kitchen:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/images/kitchen.jpg?opt=5',
  bathrooms:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/Bathrooms.jpg?opt=5',
  appliances:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/Appliances/services_appliance.jpg?opt=5',
  electrical:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/Electrical.jpg?opt=5',
  homeTheater:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/HomeTheater.jpg?opt=5',
  theater2:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/AudioVideo/theater1.jpg?opt=5',
  roofing:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/Roofing/Roofs.jpg?opt=5',
  decks:
    'https://drwzpk38qkpfb.cloudfront.net/www.totalhomeimp.com/uploaded/images/Decks/Decks.jpg?opt=5',
}

/**
 * Service-specific illustrative visuals hosted as project assets.
 * These are representative images of the type of work described — they are
 * not photographs of completed customer projects.
 */
export const serviceVisuals = {
  kitchen:
    'https://cdn.magicpatterns.com/uploads/vmnriMa6ASJ6XvHXTb39Ay/most-requested-kitchen-remodeling.png',
  bathroom:
    'https://cdn.magicpatterns.com/uploads/s9d9RdZArtMHcvajwnpFe9/most-requested-bathroom-remodeling.png',
  basement:
    'https://cdn.magicpatterns.com/uploads/vc2i4mXSNGDgTavem27bhU/most-requested-basement-finishing.png',
  plumbing:
    'https://cdn.magicpatterns.com/uploads/gTghwhkbDwemSCzLKETFKV/most-requested-plumbing.png',
  roofing:
    'https://cdn.magicpatterns.com/uploads/dR1jsXDBbwA44UtRgDQpr3/most-requested-roofing-siding-gutters.png',
  decks:
    'https://cdn.magicpatterns.com/uploads/is1p7gAXhvArBkpnNSzRPj/most-requested-decks-patios.png',
  electrical:
    'https://cdn.magicpatterns.com/uploads/b338y1YQf78sL8t7d8XzG2/most-requested-electrical-lighting.png',
  additions:
    'https://cdn.magicpatterns.com/uploads/k6cQtNhLdxz5V6PEuTRw36/most-requested-additions-new-construction.png',
  plumbingHousehold:
    'https://cdn.magicpatterns.com/uploads/aFwrUs1WtDjVEaR7bnXJMz/plumbing-leaky-faucets-running-toilet-frozen-pipes.png',
}

export const serviceVisualAlt = {
  kitchen:
    'Remodeled kitchen with new shaker cabinets, stone island countertop and stainless range, with a tradesperson finishing work at the sink',
  bathroom:
    'Finished bathroom remodel with a tiled glass shower enclosure, wood vanity and stone countertop',
  basement:
    'Finished lower-level basement living space with recessed lighting, built-in shelving and a seating area, with trim work in progress',
  plumbing:
    'Plumber servicing copper and PEX supply lines, shutoff valves and a water heater connection',
  roofing:
    'Exterior of a home showing asphalt shingle roof, lap siding and a newly hung gutter with downspout, ladder set against the eave',
  decks:
    'Backyard composite deck with railing and steps leading down to a stamped concrete patio and fire pit',
  electrical:
    'Electrician on a ladder installing a recessed ceiling light beside an open electrical panel',
  additions:
    'Two-story home addition under construction with new wood framing, sheathing and house wrap tied into the existing house',
  plumbingHousehold:
    'Plumber tightening a bathroom sink supply valve next to a toilet, with insulated supply pipes in the wall cavity',
}

export const promises = [
  {
    title: 'We stay within your BUDGET',
    body: 'The scope and the number we agree on up front is the one we work to.',
  },
  {
    title: 'We arrive ON TIME',
    body: 'When we tell you a crew will be at your door, that is when we show up.',
  },
  {
    title: 'We CLEAN UP when we leave',
    body: 'Your home is handed back the way it should be at the end of every day.',
  },
  {
    title: 'We finish on SCHEDULE',
    body: 'Work is sequenced so your project is completed when we said it would be.',
  },
]

export const credentials = [
  'Full service, licensed and insured builder',
  'State licensed and insured',
  'Member of the Better Business Bureau',
  'WE ARE LEAD SAFE EPA CERTIFIED',
]

export const bbbFacts = [
  { label: 'BBB status', value: 'BBB Accredited Business' },
  { label: 'BBB rating', value: 'A+' },
  { label: 'Accredited since', value: '11/7/2008' },
  { label: 'Business started', value: '1/1/1984' },
  { label: 'Incorporated', value: '1/1/1984' },
  { label: 'Entity type', value: 'Corporation' },
  { label: 'Alternate name', value: 'Recovery Corp' },
]

export const scopeLine =
  'We work INSIDE and OUTSIDE, from your ROOF to your BASEMENT, all FOUR SEASONS of the year.'
